import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const TaxonomyReviewScreen = lazy(
  () => import('~/features/item-setup/pages/taxonomy-review-screen'),
);

export const Route = createFileRoute('/_authenticated/_tenant/item-setup/taxonomy-review')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <TaxonomyReviewScreen />
    </Suspense>
  ),
});
